(function () {
  'use strict';

  function initCarousel(root) {
    var track = root.querySelector('[data-wuc-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-wuc-card]'));
    var prevBtn = root.querySelector('[data-wuc-prev]');
    var nextBtn = root.querySelector('[data-wuc-next]');
    var dotsWrap = root.querySelector('[data-wuc-dots]');

    if (!track || cards.length === 0) return;

    var currentIndex = 0;
    var cardsPerView = 1;
    var maxIndex = 0;
    var autoplayTimer = null;

    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 4000;

    function getCardsPerView() {
      var width = window.innerWidth;
      if (width <= 599) return 1;
      if (width <= 989) return 2;
      // Read the desktop basis percentage to infer how many fit
      var basis = getComputedStyle(cards[0]).getPropertyValue('--wuc-card-basis') || '33.3333%';
      var pct = parseFloat(basis);
      if (!pct) return 3;
      return Math.max(1, Math.round(100 / pct));
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var dotCount = Math.max(1, cards.length - cardsPerView + 1);
      for (var i = 0; i < dotCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'wuc-dot' + (i === currentIndex ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function () {
            goToIndex(idx);
            restartAutoplay();
          });
        })(i);
        dotsWrap.appendChild(dot);
      }
    }

    function updateDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.wuc-dot');
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = currentIndex <= 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }

    function getCardStep() {
      var cardRect = cards[0].getBoundingClientRect();
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return cardRect.width + gap;
    }

    function applyTransform() {
      var step = getCardStep();
      track.style.transform = 'translateX(' + (-step * currentIndex) + 'px)';
    }

    function goToIndex(index) {
      currentIndex = Math.max(0, Math.min(index, maxIndex));
      applyTransform();
      updateDots();
      updateArrows();
    }

    function recalc() {
      cardsPerView = getCardsPerView();
      maxIndex = Math.max(0, cards.length - cardsPerView);
      if (currentIndex > maxIndex) currentIndex = maxIndex;
      buildDots();
      applyTransform();
      updateArrows();
    }

    function next() {
      if (currentIndex >= maxIndex) {
        goToIndex(0);
      } else {
        goToIndex(currentIndex + 1);
      }
    }

    function prev() {
      if (currentIndex <= 0) {
        goToIndex(maxIndex);
      } else {
        goToIndex(currentIndex - 1);
      }
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      autoplayTimer = setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function restartAutoplay() {
      if (autoplay) {
        stopAutoplay();
        startAutoplay();
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        restartAutoplay();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        restartAutoplay();
      });
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    // Drag / swipe support
    var isDragging = false;
    var startX = 0;
    var startTranslate = 0;
    var currentTranslate = 0;

    function getTranslateX() {
      var step = getCardStep();
      return -step * currentIndex;
    }

    function pointerDown(e) {
      isDragging = true;
      startX = (e.touches ? e.touches[0].clientX : e.clientX);
      startTranslate = getTranslateX();
      track.classList.add('wuc-dragging');
      stopAutoplay();
    }

    function pointerMove(e) {
      if (!isDragging) return;
      var x = (e.touches ? e.touches[0].clientX : e.clientX);
      var delta = x - startX;
      currentTranslate = startTranslate + delta;
      track.style.transform = 'translateX(' + currentTranslate + 'px)';
    }

    function pointerUp(e) {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('wuc-dragging');

      var endX = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX || startX);
      var delta = endX - startX;
      var threshold = 50;

      if (delta > threshold) {
        prev();
      } else if (delta < -threshold) {
        next();
      } else {
        applyTransform();
      }
      restartAutoplay();
    }

    track.addEventListener('mousedown', pointerDown);
    track.addEventListener('touchstart', pointerDown, { passive: true });

    window.addEventListener('mousemove', pointerMove);
    track.addEventListener('touchmove', pointerMove, { passive: true });

    window.addEventListener('mouseup', pointerUp);
    track.addEventListener('touchend', pointerUp);

    // Prevent image drag ghosting
    cards.forEach(function (card) {
      var img = card.querySelector('img');
      if (img) img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(recalc, 150);
    });

    recalc();
    startAutoplay();
  }

  function init() {
    var carousels = document.querySelectorAll('[data-wuc-carousel]');
    carousels.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when section is added/edited in theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var carousels = e.target.querySelectorAll('[data-wuc-carousel]');
    carousels.forEach(initCarousel);
  });
})();